import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ImSearch } from "react-icons/im";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import api from "../../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { fetchCandidatePartialData } from "../../../redux/slice/getPartialCandidateDataSlice";
import { fetchSearchData } from "../../../redux/slice/searchDataSlice";
import { toast, ToastContainer } from "react-toastify";
import axiosPrivate from "../../../services/axios/axiosPrivate";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useHasPermission } from "hooks/useHasPermission";
import CommentIcon from "../../../assets/img/comment-history.png";
import { fetchInvitedActivityById } from "../../../redux/slice/getInvitedActivitySlice";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import BaseModal from "../../../components/common/BaseModal";
import { useForm } from "react-hook-form";

export default function Candidate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ActivityList = useSelector(
    (state) => state.ActivityList.ActivityList ?? []
  );
  const ActivityListStatus = useSelector(
    (state) => state.ActivityList.status ?? ""
  );

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingList, setEditingList] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [dob, setDob] = useState("");
  const [source, setSource] = useState("");
  const [UserId, setUserId] = useState("");
  const [showResendModal, setShowResendModal] = useState(false);
  const [permissionToResend, setPermissionToResend] = useState("");
  const { Candidates, status } = useSelector((state) => state.Candidates);
  const searchDataList = useSelector((state) => state.SearchData.SearchDataList);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [statusCount, setStatusCount] = useState(Candidates?.statusCount ?? []);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [activityFeed, setActivityFeed] = useState(ActivityList);
  const [originalEmail, setOriginalEmail] = useState("");
  const [restCandidate, setRestCandidate] = useState([]);
  const [displayedCandidates, setDisplayedCandidates] = useState(restCandidate);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [sortBy] = useState("creationDate");  // default for API
  const [direction] = useState("desc");     // default latest first
  const [sortConfig, setSortConfig] = useState({
    key: "creationDate",
    direction: "desc"
  });

  const canViewCandidate = useHasPermission("Candidate-view");
  const canEditCandidate = useHasPermission("Candidate-manage");
  const canViewAddCandidate = useHasPermission("Add Candidate-view");
  const canViewCandidateDetails = useHasPermission("Candidate Details-view");
  const canViewResendLink = useHasPermission("Resend Activation Link-view");
  const canEditResendLink = useHasPermission("Resend Activation Link-manage");
  const canViewExport = useHasPermission("Export Candidate Data-view");
  const canEditExport = useHasPermission("Export Candidate Data-manage");
  const canViewCommentHistory = useHasPermission("Comment History-view");

  const { register, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm({ mode: "onChange" });
  useEffect(() => {
    if (showEditModal) {
      console.log("reset source:", source);
      reset({
        firstName,
        middleName,
        lastName,
        emailId,
        mobileNo,
        dob: dob?.slice(0, 10) || "",
        source,
      });
    }
  }, [showEditModal, reset, firstName, middleName, lastName, emailId, mobileNo, dob, source]);
  useEffect(() => { setActivityFeed(ActivityList); }, [ActivityList]);

  useEffect(() => {
    setTotalItems(searchDataList?.totalItems)
    setTotalPages(searchDataList?.totalPages)
    setCurrentPage(searchDataList?.pageNo)
    setStatusCount(searchDataList?.statusCount)
    setRestCandidate(searchDataList?.result);
    setDisplayedCandidates(searchDataList?.result);
  }, [searchDataList]);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setTotalItems(Candidates?.totalItems)
      setTotalPages(Candidates?.totalPages)
      setCurrentPage(Candidates?.currentPage)
      setStatusCount(Candidates?.statusCount)
      setRestCandidate(Candidates?.content);
      setDisplayedCandidates(Candidates?.content);
    }
  }, [dispatch, Candidates, totalPages, totalItems, currentPage, searchTerm, statusCount, filterStatus, sortBy, direction]);

  useEffect(() => {
    if (canViewCandidate && currentPage === 1) {
      dispatch(fetchCandidatePartialData({ page: 1, SB: "creationDate", order: "desc", candidateStatus: filterStatus, size: pageSize }));
    }
  }, [dispatch, canViewCandidate, filterStatus]);

  useEffect(() => {
    if (!searchTerm || searchTerm.trim().length < 1) {
      return;
    }
    const timerId = setTimeout(() => {
      dispatch(fetchSearchData({ type: "candidate", keyword: searchTerm.trim(), page: 0, size: pageSize }));
    }, 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, [searchTerm, dispatch]);

  if (!canViewCandidate) {
    return (
      <p className="perm-msg">You don’t have permission to view candidate page!</p>
    );
  };

  const handleEditClick = (list) => {
    if (!canEditCandidate) {
      toast.error("You don't have permission to edit candidate details", { className: "toast-error-custom", autoClose: 5000, });
      return;
    }
    setEditingList(list);
    setFirstName(list.firstName);
    setMiddleName(list.middleName);
    setLastName(list.lastName);
    setEmailId(list.email);
    setOriginalEmail(emailId);
    setMobileNo(list.mobile);
    setDob(list.dateOfBirth);
    setSource(list.source)
    setUserId(list.userId);
    setShowEditModal(true);
  };

  const handleUpdateList = async (data) => {
    if (!canEditCandidate) {
      toast.error("You don't have permission to edit candidate details", { className: "toast-error-custom", autoClose: 5000 });
      return;
    }
    event.preventDefault();
    if (!editingList) return;

    try {
      const url = `${api.updateInviteCandidate}`;
      const updatedData = {
        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,
        email: data.emailId,
        mobile: data.mobileNo,
        dob: data.dob,
        userId: UserId,
        source: data.source,
      };
      const response = await axiosPrivate.post(url, updatedData);
      if (response?.data?.success === true) {
        setShowEditModal(false);
        setEditingList(null);
        dispatch(fetchCandidatePartialData({ page: currentPage + 1, SB: sortBy, order: direction, candidateStatus: filterStatus, size: pageSize }));
        toast.success(response?.data?.reason || "candidate details are updated successfully!", { className: "toast-success-custom" });

        if (originalEmail !== emailId) {
          try {
            const formData = new FormData();
            formData.append("email", emailId);
            const result = await axiosPrivate.post(
              api.resendActivationLink,
              formData
            );
            if (result?.data?.success === true) {
              toast.success(
                result?.data?.reason ||
                "Resend Activation Link successfully!",
                { className: "toast-success-custom" }
              );
              setPermissionToResend(null);
            }
          } catch (err) {
            toast.error(err?.data?.reason || "-- Unable to connect to server --", { className: "toast-error-custom", });
          }
        }
      } else {
        toast.error(response?.data?.reason, { className: "toast-error-custom" });
      }
    } catch (error) {
      toast.error(error?.message || "-- Unable to connect to server --", { className: "toast-error-custom" });
    }
  };

  const onUpdate = (data) => {
    handleUpdateList(data);
  };
  const handleResendClick = (email) => {
    if (!canViewResendLink) {
      toast.error("You don't have permission to resend activation link", { className: "toast-error-custom", autoClose: 5000 });
      return;
    }
    setPermissionToResend(email);
    setShowResendModal(true);
  };

  const handleConfirmResend = async () => {
    if (!canEditResendLink) {
      toast.error("You don't have permission to resend activation link", { className: "toast-error-custom", autoClose: 5000 });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("email", permissionToResend);
      const result = await axiosPrivate.post(
        api.resendActivationLink,
        formData
      );
      if (result?.data?.success === true) {
        toast.success(
          result?.data?.reason || "Resend Activation Link successfully...", { className: "toast-success-custom" });
        setShowResendModal(false);
        setPermissionToResend(null);
      }
    } catch (err) {
      toast.error(err?.data?.reason || "-- Unable to connect to server --", { className: "toast-error-custom" });
    }
  };
  const handleAddNewClick = () => {
    if (!canViewAddCandidate) {
      toast.error("You don't have permission to add new candidate", { className: "toast-error-custom", autoClose: 5000 });
      return;
    }
    navigate("/admin/candidate/register");
  };

  const handleViewDetailsClick = (id, invitedBy) => {
    if (!canViewCandidateDetails) {
      toast.error("You don't have permission to see candidate details", { className: "toast-error-custom", autoClose: 5000 });
      return;
    }
    navigate(`/admin/candidate/details/${id}`, { state: { invitedBy } });
  };

  const handleViewCommentHistoryClick = (id) => {
    dispatch(fetchInvitedActivityById(id));
    setShowActivityModal(true);
    setActivityFeed(ActivityList)
  };

  const renderTooltip = (props, description) => (
    <Tooltip id="button-tooltip" {...props}>
      {description}
    </Tooltip>
  );

  const formatDateTime = (isoString) => {
    if (!isoString) return { date: "N/A", time: "N/A" };

    const dateObj = new Date(isoString);
    const date = dateObj.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = dateObj.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return { date, time };
  };

  const toSentenceCase = (str) => {
    if (!str) return "";
    const normalizedStr = str.toLowerCase().replaceAll(/_/g, " ");
    return normalizedStr.charAt(0).toUpperCase() + normalizedStr.slice(1);
  };

  const handlePageChange = (_, value) => {
    if (canViewCandidate) {
      if (searchTerm.trim() === '') {
        dispatch(fetchCandidatePartialData({ page: value, SB: sortBy, order: direction, candidateStatus: filterStatus, size: pageSize }));
      } else {
        dispatch(fetchSearchData({ type: "candidate", keyword: searchTerm.trim(), page: value - 1, size: pageSize }));
      }
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const applyStatusFilter = (statusKey) => {
    setFilterStatus(statusKey);
    setCurrentPage(1);
    dispatch(fetchCandidatePartialData({
      page: 1,
      SB: sortBy,
      order: direction,
      candidateStatus: statusKey,
      size: pageSize
    }));
    setSearchTerm('');
  };

  const statusMap = (statusCount || []).reduce((acc, curr) => {
    acc[curr.status] = curr.count;
    return acc;
  }, {});

  const cardItems = [
    {
      label: "Total Candidate",
      key: "",
      count: totalItems
    },
    {
      label: "Pending",
      key: "PENDING",
      count: statusMap["PENDING"] || 0
    },
    {
      label: "Partial Completed",
      key: "PARTIAL_COMPLETED",
      count: statusMap["PARTIAL_COMPLETED"] || 0
    },
    {
      label: "Completed",
      key: "COMPLETED",
      count: statusMap["COMPLETED"] || 0
    },
    {
      label: "Back For Revision",
      key: "SENT_BACK_FOR_REVISION",
      count: statusMap["SENT_BACK_FOR_REVISION"] || 0
    },
    {
      label: "Verified",
      key: "VERIFIED",
      count: statusMap["VERIFIED"] || 0
    },
    {
      label: "Rejected",
      key: "REJECTED",
      count: statusMap["REJECTED"] || 0
    },
    {
      label: "Approved",
      key: "APPROVED",
      count: statusMap["APPROVED"] || 0
    },
  ];

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      dispatch(fetchSearchData({ type: "candidate", keyword: searchTerm.trim(), page: 0, size: pageSize }));
    }
  };

  const handleHeaderClick = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...displayedCandidates].sort((a, b) => {
      let valA = a[key];
      let valB = b[key];

      // date sorting
      if (key === "creationDate") {
        valA = new Date(a.creationDate);
        valB = new Date(b.creationDate);
      } else {
        valA = valA ? valA.toString().toLowerCase() : "";
        valB = valB ? valB.toString().toLowerCase() : "";
      }

      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setDisplayedCandidates(sortedData);
  };
  const today = new Date().toISOString().split("T")[0];
  const editFields = [
    {
      name: "firstName",
      label: "First Name",
      type: "text",
      rules: {
        required: "First name is required",
        pattern: {
          value: /^[a-zA-Z\s]+$/,
          message: "Numbers and special characters are not allowed"
        }
      }
    },
    {
      name: "middleName",
      label: "Middle Name",
      type: "text",
      rules: {
        pattern: {
          value: /^[a-zA-Z\s]+$/,
          message: "Numbers and special characters are not allowed"
        }
      }
    }, {
      name: "lastName",
      label: "Last Name",
      type: "text",
      rules: {
        required: "Last name is required",
        pattern: {
          value: /^[a-zA-Z\s]+$/,
          message: "Numbers and special characters are not allowed"
        }
      }
    },
    {
      name: "emailId",
      label: "Email Id",
      type: "email",
      rules: {
        required: "Email is required",
        pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "Invalid email format" }
      },
    }, {
      name: "mobileNo",
      label: "Mobile No.",
      type: "text",
      rules: {
        required: "Mobile number is required",
        pattern: {
          value: /^[0-9]{10}$/,
          message: "Please enter a valid 10-digit mobile number"
        },
        minLength: { value: 10, message: "Mobile number must be exactly 10 digits" },
        maxLength: { value: 10, message: "Mobile number cannot exceed 10 digits" }
      },
    }, {
      name: "dob",
      label: "Date Of Birth",
      type: "date",
      max: today,
      rules: {
        required: "DOB is required",
        validate: (v) => new Date(v) <= new Date() || "Date cannot be in the future"
      },
    }, {
      name: "source",
      label: "Source Of Candidate",
      type: "select",
      options: [
        { value: "Referral", label: "Referral" },
        { value: "Recruitment Department", label: "Recruitment Department" }
      ],
      rules: {
        required: "Source is required"
      }
    }
  ];

  return (
    <div className="container-fluid">
      <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse", marginBottom: "18px" }}>
        <div className="icons-list">
          <Breadcrumb />
          {canViewAddCandidate ? (
            <div>
              <button
                type="button"
                className="primary-btn ml-4"
                onClick={() => handleAddNewClick()}
              >
                <i className="fe fe-plus"></i>+ Add Candidate
              </button>
            </div>
          ) : ("")}
        </div>
      </div>
      {/* counters */}
      <div className="top-filter-section">
        <h6 style={{ fontWeight: 600, marginBottom: 12 }}>Filters: <em style={{ fontSize: 12, textTransform: "capitalize" }}>Filter the candidate list using the options below.</em></h6></div>
      <div className="row cadidate-filter">
        {cardItems.map((item) => (
          <div key={item.id} className="col-lg-3 col-md-6 col-sm-6 col-xs-6">
            <button type="button"
              className={`btn-interactive card clickable-card ${filterStatus === item.key ? "active-card" : ""}`}
              onClick={() => applyStatusFilter(item.key)}
            >
              <div className="card-body w_sparkline">
                <div className="d-flex align-middle w-100 filter-container">
                  <span>{item.label}</span>
                  <strong className="h6 font-weight-bold mb-0 mt-0">
                    {item.count ?? 0}
                  </strong>
                </div>
              </div>
            </button>
          </div>
        ))}
      </div>

      {/* user list table */}
      <div className="section-body">
        <div className="container-fluid">
          <div className="tab-content">
            <div className="tab-pane fade active show" id="Employee-list" role="tabpanel" >
              <div className="card">
                <div className="card-header">
                  <div className="employeelist-header">
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 400 }}
                      overlay={(props) =>
                        renderTooltip(
                          props,
                          "Search by candidate name, id or mobile no."
                        )
                      }
                    >
                      <form className="user-searchForm ml-2" onSubmit={handleFormSubmit}>
                        <input
                          className="form-control me-2 search"
                          type="search"
                          placeholder="Search candidate"
                          aria-label="Search"
                          value={searchTerm}
                          onChange={handleInputChange}
                        />
                        <button type="submit" className="btn-interactive" onClick={handleFormSubmit} aria-label="Submit Search">
                          <ImSearch className="searchIcon" />
                        </button>
                      </form>
                    </OverlayTrigger>

                    <div className="d-flex align-items-center" style={{ gap: "10px" }} >
                      <h3 className="card-title mb-0 ml-4 ">Page Limit:</h3>
                      <select
                        className="custom-select"
                        value={pageSize}
                        onChange={(e) => {
                          const value =
                            e.target.value === "all"
                              ? totalItems
                              : Number(e.target.value);

                          setPageSize(value);
                          setCurrentPage(1);

                          if (searchTerm.trim() === "") {
                            dispatch(
                              fetchCandidatePartialData({
                                page: 1,
                                SB: sortBy,
                                order: direction,
                                candidateStatus: filterStatus,
                                size: value,
                              })
                            );
                          } else {
                            dispatch(
                              fetchSearchData({
                                type: "candidate",
                                keyword: searchTerm.trim(),
                                page: 0,
                                size: value,
                              })
                            );
                          }
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={40}>40</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value="all">All</option>
                      </select>
                    </div>
                  </div>

                  <div className="card-body">
                    {status === "loading" && (<p className="loading">Loading...</p>)}
                    {status === "failed" && (<p className="server-error-msg">-- Unable to connect to server --</p>)}
                    {status == "succeeded" && (
                      <div className="user-table">
                        <table
                          id="candidate-table"
                          className="table table-hover table-vcenter text-nowrap mb-0"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "55px", textAlign: "center" }}>S.No.</th>

                              <th onClick={() => handleHeaderClick("firstName")}>
                                Name
                                {sortConfig.key === "firstName" &&
                                  (sortConfig.direction === "asc" ? "▲" : "▼")}
                              </th>
                              <th style={{ width: "110px" }}>ID</th>
                              <th>Email ID</th>
                              <th style={{ width: "110px" }}>Mobile No.</th>

                              <th onClick={() => handleHeaderClick("invitedBy")}>
                                Invited By{" "}
                                {sortConfig.key === "invitedBy" &&
                                  (sortConfig.direction === "asc" ? "▲" : "▼")}
                              </th>

                              <th style={{ width: "150px" }} onClick={() => handleHeaderClick("creationDate")}>
                                Invitation Date{" "}
                                {sortConfig.key === "creationDate" &&
                                  (sortConfig.direction === "asc" ? "▲" : "▼")}
                              </th>

                              <th
                                style={{ width: "95px", textAlign: "center" }}
                                onClick={() => handleHeaderClick("documentUploadStatus")}
                              >
                                Status{" "}
                                {sortConfig.key === "documentUploadStatus" &&
                                  (sortConfig.direction === "asc" ? "▲" : "▼")}
                              </th>

                              <th className="action-header"
                                style={{ width: '62px', textAlign: 'center' }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          {displayedCandidates?.length === 0 ? (
                            <p className="no-record-msg server-error-msg">-- No record found for candidates --</p>
                          ) : (
                            <tbody>
                              {displayedCandidates?.map((list, index) => {
                                const menuActions = [
                                  {
                                    label: "View",
                                    icon: require("assets/img/view-icon.png"),
                                    title: canViewCandidateDetails ? "view" : "No permisssion to view candidate",
                                    permission: canViewCandidateDetails,
                                    onClick: () =>
                                      handleViewDetailsClick(
                                        list.userId,
                                        list.invitedBy,
                                      ),
                                    show: true,
                                  },
                                  {
                                    label: "Edit",
                                    icon: require("assets/img/edit-icon.png"),
                                    title: canEditCandidate ? "edit" : "No permisssion to edit candidate",
                                    permission: canEditCandidate,
                                    onClick: () => handleEditClick(list),
                                    show: [
                                      "PENDING"
                                    ].includes(list.documentUploadStatus),
                                  },
                                  {
                                    label: "Resend Activation Link",
                                    icon: require("assets/img/resend-link.png"),
                                    title: canViewCandidateDetails ? "resend activation link" : "No permisssion resend activation link",
                                    permission: canViewResendLink,
                                    onClick: () =>
                                      handleResendClick(list.email),
                                    show: [
                                      "PENDING",
                                      "PARTIAL_COMPLETED",
                                    ].includes(list.documentUploadStatus),
                                  },
                                  {
                                    label: "Comment History",
                                    icon: require("assets/img/comment-history.png"),
                                    title: canViewCandidateDetails ? "comment history" : "No permisssion to view comment history",
                                    permission: canViewCommentHistory,
                                    onClick: () =>
                                      handleViewCommentHistoryClick(
                                        list.userId,
                                      ),
                                    show: true,
                                  },
                                ];
                                return (
                                  <tr key={list.userId} onClick={() => {
                                    if (canViewCandidateDetails) {
                                      handleViewDetailsClick(list.userId, list.invitedBy);
                                    }
                                  }} style={{ cursor: canViewCandidateDetails ? "pointer" : "default" }}
                                  >
                                    <td>{(pageSize * (currentPage)) + index + 1}.</td>
                                    <td>
                                      <button type="button" className="btn-interactive" style={{ cursor: canViewCandidateDetails ? "pointer" : "default" }} onClick={() => {
                                        if (canViewCandidateDetails) {
                                          handleViewDetailsClick(list.userId, list.invitedBy);
                                        }
                                      }}>
                                        {list.fullName ?? list.firstName}
                                      </button>
                                    </td>
                                    <td>{`cand-0${list.userId}`}</td>
                                    <td>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id={`email-tooltip-${list.userId}`}>
                                            {list?.email ?? "-"}
                                          </Tooltip>
                                        }
                                      >
                                        <span style={{ cursor: 'pointer' }}>
                                          {list?.email ?? "-"}
                                        </span>
                                      </OverlayTrigger>
                                    </td>
                                    <td>{list.mobile ?? "-"}</td>
                                    <td>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id={`invited-tooltip-${list.userId}`}>
                                            {list?.invitedBy ?? "-"}
                                          </Tooltip>
                                        }
                                      >
                                        <span style={{ cursor: 'pointer' }}>
                                          {list?.invitedBy ?? "-"}
                                        </span>
                                      </OverlayTrigger>
                                    </td>
                                    <td>{formatDateTime(list.creationDate)?.date ?? "-"}</td>
                                    <td>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id={`status-tooltip-${list.userId}`}>
                                            {list.documentUploadStatus
                                              ? toSentenceCase(list.documentUploadStatus)
                                              : "PENDING"}
                                          </Tooltip>
                                        }
                                      >
                                        <span style={{ cursor: 'pointer' }}>
                                          {list.documentUploadStatus
                                            ? toSentenceCase(list.documentUploadStatus)
                                            : "PENDING"}
                                        </span>
                                      </OverlayTrigger>
                                    </td>
                                    <td className="action-column">
                                      <PopupState
                                        variant="popover"
                                        popupId="demo-popup-menu"
                                      >
                                        {(popupState) => (
                                          <>
                                            <button
                                              type="button"
                                              className="btn btn-icon btn-sm icons"
                                              {...bindTrigger(popupState)}
                                            >
                                              <img
                                                src={require("assets/img/more.png")}
                                                alt="more"
                                                className="action-icon"
                                                style={{
                                                  opacity: canViewCandidate
                                                    ? 1
                                                    : 0.5,
                                                }}
                                              />
                                            </button>

                                            <Menu {...bindMenu(popupState)}>
                                              {menuActions
                                                .filter(
                                                  (action) => action.show,
                                                )
                                                .map((action, index) => (
                                                  <MenuItem
                                                    key={index}
                                                    disabled={
                                                      !action.permission
                                                    }
                                                    onClick={() => {
                                                      popupState.close();
                                                      if (action.permission)
                                                        action.onClick();
                                                    }}
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-icon btn-sm icons me-2"
                                                      title={
                                                        action.permission
                                                          ? action.label
                                                          : "No permission"
                                                      }
                                                      disabled={
                                                        !action.permission
                                                      }
                                                    >
                                                      <img
                                                        src={action.icon}
                                                        alt={action.label}
                                                        className="action-icon"
                                                        style={{
                                                          opacity:
                                                            action.permission
                                                              ? 1
                                                              : 0.5,
                                                        }}
                                                      />
                                                    </button>
                                                    {action.label}
                                                  </MenuItem>
                                                ))}
                                            </Menu>
                                          </>
                                        )}
                                      </PopupState>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          )}
                        </table>
                        {displayedCandidates?.length > 0 ? (
                          <Stack
                            spacing={2}
                            sx={{ marginTop: 3, alignItems: "center" }}
                          >
                            <Pagination
                              count={totalPages}
                              page={currentPage + 1}
                              onChange={handlePageChange}
                              shape="rounded"
                              color="primary"
                              disabled={status === "loading"}
                            />
                          </Stack>
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <BaseModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        title="Edit Details"
        footerButtons={
          <>
            <Button
              variant="cancel-cta"
              onClick={() => setShowEditModal(false)}
            >
              Close
            </Button>
            <Button
              variant="update-cta"
              onClick={handleSubmit(onUpdate)}
              disabled={!canEditCandidate}
            >
              Update
            </Button>
          </>
        }
      >
        {/* <Form onSubmit={handleSubmit(onUpdate)} >
          {editFields.map((field) => (
            <Form.Group key={field.label} className="mb-3">
              <Form.Label>{field.label}</Form.Label>
              <Form.Control
                type={field.type}
                max={field.max}
                {...register(field.name, field.rules)}
                onInput={(e) => {
                  if (field.name === "mobileNo") {
                    e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  }
                }}
              />
              {errors[field.name] && (
                <p className="error-msg"> {errors[field.name]?.message} </p>
              )}
            </Form.Group>
          ))}
        </Form> */}
        <Form onSubmit={handleSubmit(onUpdate)}>
          {editFields.map((field) => (
            <Form.Group key={field.name} className="mb-3">
              <Form.Label>{field.label}</Form.Label>

              {field.type === "select" ? (
                <Form.Select
                  value={watch(field.name) || ""}
                  onChange={(e) => setValue(field.name, e.target.value)}
                >
                  <option value="">Select Source</option>

                  {field.options?.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              ) : (
                <Form.Control
                  type={field.type}
                  max={field.max}
                  {...register(field.name, field.rules)}
                  onInput={(e) => {
                    if (field.name === "mobileNo") {
                      e.target.value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);
                    }
                  }}
                />
              )}

              {errors[field.name] && (
                <p className="error-msg">{errors[field.name]?.message}</p>
              )}
            </Form.Group>
          ))}
        </Form>
      </BaseModal>
      <BaseModal
        show={showResendModal}
        onHide={() => setShowResendModal(false)}
        title="Confirm Resend Activation Link"
        footerButtons={
          <>
            <Button
              variant="cancel-cta"
              style={{ color: "white" }}
              onClick={() => setShowResendModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="update-cta"
              style={{ backgroundColor: "red", color: "white" }}
              onClick={handleConfirmResend}
              disabled={!canEditResendLink}
            >
              Resend
            </Button>
          </>
        }
      >
        Are you sure you want to resend the activation link?
      </BaseModal>
      <BaseModal
        show={showActivityModal}
        onHide={() => setShowActivityModal(false)}
        title="Candidate Comments History"
        footerButtons={
          <Button
            variant="cancel-cta"
            onClick={() => setShowActivityModal(false)}
          >
            Close
          </Button>
        }
      >
        <h5 className="mb-3">Activity Timeline</h5>
        {ActivityListStatus === "loading" ? (
          <p>Loading....</p>
        ) : (
          <ListGroup variant="flush">
            {activityFeed?.length > 0 ? (
              activityFeed.map((activity) => {
                const { date, time } = formatDateTime(
                  activity.creationDate || activity.whatTime,
                );
                return (
                  <ListGroup.Item
                    key={activity.id}
                    className="d-flex align-items-start py-3 px-0 border-bottom"
                  >
                    <div style={{ marginRight: "15px", flexShrink: 0 }}>
                      <img
                        src={CommentIcon}
                        alt="Activity"
                        style={{ width: "18px", marginTop: "3px" }}
                      />
                    </div>
                    <div className="flex-grow-1">
                      <p
                        className="mb-1"
                        style={{ fontSize: "0.85rem", color: "#6c757d" }}
                      >
                        <span className="fw-bold">{date}</span> {time}{" "}
                        {activity.who && ` | ${activity.who}`}
                      </p>
                      <p className="mb-0">{activity.what}</p>
                    </div>
                  </ListGroup.Item>
                );
              })
            ) : (
              <p>No History</p>
            )}
          </ListGroup>
        )}
      </BaseModal>
      <ToastContainer />
    </div>
  );
}
